export default "/institutions/brb.svg";